import * as _ from 'lodash';
import { IAdpRecipientFromChain } from '@nkr/models/index';
import { SwapGridWrapper } from '../styles';
import { Utility } from '@nkr/services/utility';
import SingleEpletMmRisk from '@nkr/views/swap-management/single-eplet-mm-risk';
import AlleleMatch from '@nkr/components/allele-match';

interface IProps {
    list: IAdpRecipientFromChain[],
    sidebar?: boolean
}

const AdpRecipientsFromChain = (props: IProps) => {
    const sortedList = _.sortBy(props.list, [
        x => x.chainId,
        x => x.clusterNumber,
        x => x.donorPosition
    ]);

    return (
        <SwapGridWrapper condensed bordered style={{ fontSize: props.sidebar ? 12 : null }}>
            <thead>
                <tr>
                    <th rowSpan={2}>Swap</th>

                    <th colSpan={4}>Donor</th>

                    <th colSpan={6}>Recipient</th>

                    <th rowSpan={2}>Eplet<br />MM</th>
                    <th rowSpan={2}>Allele<br />Match</th>
                    <th colSpan={2}>Actual Surgery Dates</th>
                </tr>
                <tr>
                    <th>Center</th>
                    <th>Alias</th>
                    <th>ABO</th>
                    <th>Age</th>

                    <th>Center</th>
                    <th>Alias</th>
                    <th>ABO</th>
                    <th>Age</th>
                    <th>cPRA4</th>
                    <th>Wait Time</th>

                    <th>Donor</th>
                    <th>Recipient</th>
                </tr>
            </thead>
            <tbody>
                {sortedList.map(position =>
                    <tr>
                        <td style={{ textAlign: 'center' }}>{position.chainId}/{position.clusterNumber}/{position.donorPosition}</td>
                        <td style={{ textAlign: 'center' }}>{position.donorCenterAlias}</td>
                        <td style={{ textAlign: 'center' }}>{position.donorAlias}</td>
                        <td style={{ textAlign: 'center' }}>{Utility.realBloodType(position.donorBloodType, position.donorA1, position.donorAb1)}</td>
                        <td style={{ textAlign: 'center' }}>{position.donorAge}</td>
                        <td style={{ textAlign: 'center' }}>{position.recipientCenterAlias}</td>
                        <td style={{ textAlign: 'center' }}>{position.recipientAlias}</td>
                        <td style={{ textAlign: 'center' }}>{position.recipientBloodType}</td>
                        <td style={{ textAlign: 'center' }}>{position.recipientAge}</td>
                        <td style={{ textAlign: 'center' }}>{position.cpra4}</td>
                        <td style={{ textAlign: 'center' }}>{position.wait}</td>
                        <td style={{ textAlign: 'center' }}><SingleEpletMmRisk data={position.epletMm} isAdmin={true} placement={props.sidebar ? "left" : undefined} /></td>
                        <td style={{ textAlign: 'center' }}><AlleleMatch bmtMm={position.bmtMm} displayAsInline={false} /></td>
                        <td style={{ textAlign: 'center' }}>{position.txpDate}</td>
                        <td style={{ textAlign: 'center' }}>{position.txpDate}</td>
                    </tr>
                )}
            </tbody>
        </SwapGridWrapper>
    )
}

export default AdpRecipientsFromChain;